export default __webpack_public_path__ + "static/media/folder-closed-16.2fd23977.svg";